<template>
	<v-card ref="selectionRoot" :id="`${elementKey}_kind_tree_selection`" elevation="0" color="transparent" @click.stop @keydown="nextItem">
		<v-text-field
			style="position: relative"
			v-model="search"
			:color="color"
			:background-color="bgColor"
			:outlined="outlined"
			:solo="solo"
			:flat="flat"
			:placeholder="placeholder"
			:disabled="disabled"
			:error="error"
			dense
			hide-no-data
			hide-details
			clearable
			@click.stop="queryKinds()"
			@click:clear.stop="onSelected(null)"
		>
			<template v-if="isKindIcon" v-slot:prepend-inner>   
				<Kind width="20" height="20" :color="error ? '#F45252':'rgba(25, 42, 62, 0.5)'"/>     
			</template>
			<template v-slot:append>
				<div v-if="loading" class="load"></div>
				<v-icon v-else :disabled="disabled" :color="error ? '#F45252':'rgba(25, 42, 62, 0.5)'" @click.stop="queryKinds()">mdi-menu-down</v-icon>
			</template>
		</v-text-field>
		<v-card-text v-if="is_open" class="pa-0 tree-container tree-wrap" :style="`top: ${top}px;left: ${left}px; ${isWidthAuto ? `width: ${whole_width}px` : `width: ${max_width}px`}`">
			<div class="tree-wrap-container">
				<v-treeview
					v-if="result_list.length === 0"
					:items="kindItems"
					:color="color"
					item-text="name"
					activatable
					open-all
					open-on-click
					return-object
					hoverable
					dense
					expand-icon="mdi-chevron-down"
					@update:active="onSelected"
				>
				</v-treeview>
				<v-list-item-group
					v-if="result_list.length !== 0"
					v-model="selectedItem"
				>
					<v-list-item
						v-for="item in result_list"
						:key="item.id"
						dense
						@click="onSelected([item])"
					>
						<span>{{ item.name }}</span>
					</v-list-item>
				</v-list-item-group>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import Kind from "@/components/icons/kind.vue";

const Categories_Type = 0;
const KIND = 2;
const ITEM = 1;

const Key_Code_Up = 38;
const Key_Code_Down = 40;
const Key_Code_Enter = 13;

export default {
	name: 'KindTreeSelection',
	props: {
		kindParams: {
			type: Object,
			default: () => {}
		},
		isKindIcon: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: '#FFFFFF'
		},
		bgColor: {
			type: String,
			default: ''
		},
		kindSelected: {
			type: Object,
			default: null
		},
		outlined: {
			type: Boolean,
			default: true
		},
		solo: {
			type: Boolean,
			default: false
		},
		flat: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		isWidthAuto: {
			type: Boolean,
			default: false
		},
		closeSelection: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
		elementKey: {
			type: String,
			default: '00'
		},
		error: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Kind,
	},
	data() {
		this.breakpoint_width = 400;

		return { 
			loading: false,
			is_open: false,
			kind_data: [],
			search: this.kindSelected !== null ? this.kindSelected.display_name : null,
			result_list: [],
			selectedItem: -1,

			max_width: 0,
			whole_width: 0,
			top: 0,
			left: 0
		}
	},
	watch: {
		kindSelected() {
			this.search = this.kindSelected !== null ? this.kindSelected.display_name : null;
		},
		closeSelection() {
			this.is_open = false;
			this.result_list = [];
		},
		async search(newVal, oldVal) {
			if (newVal !== oldVal && newVal && (this.kindSelected ? newVal !== this.kindSelected.display_name : true) ) {
				if (this.kindItems.length === 0 && !this.is_open) {
					await this.queryKinds();					
				}

				this.result_list = [];

				const result_list_code = [];
				const result_list_display_name = [];
				this.kindItems.forEach(k => {
					if (k.children && k.children.length !== 0) {
						k.children.forEach(c => {
							if (!c.children) {
								const text = c.display_name.toLowerCase();
								const result = c.type !== Categories_Type && (text.indexOf(newVal.toLowerCase()) > -1);

								const code = c.code.toLowerCase();
								const result_code = c.type !== Categories_Type && (code.indexOf(newVal.toLowerCase()) > -1);
								
								if (result) {
									result_list_display_name.push(c);
								}
								if (result_code) {
									result_list_code.push(c)
								}
							}
							
							if (c.children && c.children.length !== 0) {
								c.children.forEach(child => {
									const text = child.display_name.toLowerCase();
									const result = child.type !== Categories_Type && (text.indexOf(newVal.toLowerCase()) > -1);

									const code = child.code.toLowerCase();
									const result_code = child.type !== Categories_Type && (code.indexOf(newVal.toLowerCase()) > -1);

									if (result) {
										result_list_display_name.push(child);
									}
									if (result_code) {
										result_list_code.push(child)
									}
								})
							}
						})
					}
				});

				const result_list_code_ids = result_list_code.map(l => { return l.id });
				const un_result_list_code = result_list_display_name.filter(l => { return !result_list_code_ids.includes(l.id) });
				this.result_list = [...result_list_code, ...un_result_list_code];

				if (!this.is_open && this.result_list.length !== 0) {
					this.is_open = true;
				}
				
			}
		},
		kindItems() {
			if (this.kindItems.length === 0) {
				this.is_open = false;
				this.$emit('no-data', true)
			} else {
				this.is_open = true;
			}
		}
	},
	computed: {
		kindItems() {
			const kind_items = [];
			if (this.kind_data.length !== 0) {
				this.kind_data.forEach(object_item => {
					for (const [key, value] of Object.entries(object_item)) {
						if (key === 'kinds') {
							if (value) {
								value.forEach(v => {
									v['name'] = `${v.code} - ${v.display_name}`;

									if (v.subkinds && v.subkinds.length !== 0) {
										v.subkinds.forEach(sub => {
											sub['name'] = `${sub.code} - ${sub.display_name}`;
										});
									}
									v['children'] = v.subkinds;								
								});
							}
							object_item['children'] = value;
						} else {
							object_item[`${key}`] = value;
						}
					}

					if (object_item.type === Categories_Type && object_item.children) {
						object_item['name'] = object_item.display_name;
						kind_items.push(object_item);
					}	
				});
			}
			return kind_items;
		}
	},
	methods: {
		nextItem (event) {
			if (event.keyCode === Key_Code_Up && this.selectedItem > 0) {
				this.selectedItem--
			} else if (event.keyCode === Key_Code_Down && this.selectedItem < this.result_list.length) {
				this.selectedItem++
			} else if (event.keyCode === Key_Code_Enter && this.result_list.length !== 0 && this.selectedItem >= 0) {
				const item = this.result_list[this.selectedItem];
				this.onSelected([item]);
			}
		},
		async queryKinds() {
			if (this.disabled === true) return;

			this.result_list = [];
			const elem_ref = this.$refs.selectionRoot;
			const elem = elem_ref && elem_ref.$el ? elem_ref.$el : elem_ref;
			if (!elem) return;
			const diff_bottom = this.$vuetify.breakpoint.height - elem.getBoundingClientRect().bottom;

			this.max_width = elem.clientWidth;
			const parent_width = elem.parentNode && elem.parentNode.parentNode ? elem.parentNode.parentNode.clientWidth : elem.clientWidth;
			this.whole_width = parent_width <= this.breakpoint_width ? this.breakpoint_width : parent_width;

			this.top = diff_bottom >= 240 ? elem.getBoundingClientRect().bottom : (elem.getBoundingClientRect().top - 240);
			this.left = elem.getBoundingClientRect().left;
			
			this.loading = true;

			const params = [];
			for (const [key, value] of Object.entries(this.kindParams)) {
				params.push(`${key}=${value}`);
			}
			
			let url = "/api/kinds/tree";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;
					if (status === 'OK') {
						this.kind_data = data;
					} else {
						this.$emit('error', reason)
					}
				})
				.catch((e) => {
					this.$emit('error', e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onSelected(value) {
			if (value) {
				const selected_item = value[0];
				if (selected_item && !selected_item.children) {
					this.result_list = [];
					this.search = value[0].display_name;

					setTimeout(() => {
						this.is_open = false;
					}, 300);
					
					this.$emit('kind-selected', value[0]);
					this.selectedItem = -1;
				}
			} else {
				this.$emit('kind-selected', value);
				this.selectedItem = -1;
			}
		},
		_isKind(type, unit) {
			let is_kind = false;
			if (unit === KIND && (type === KIND || type === ITEM) ) {
				is_kind = true;
			}
			return is_kind;
		},
		_isItem(type, unit) {
			let is_item = false;
			if (type === KIND && unit === ITEM) {
				is_item = true;
			}
			return is_item;
		}
	}
}
</script>
<style lang="scss" scoped>
.tree-container {
	position: fixed;
	z-index: 12;
	background-color: #FFFFFF;
	box-shadow: 0px 1px 1px #192A3E;

	height: 240px;
	overflow-y: auto;
}
.tree-wrap {
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}
.load {
	border: 2px solid #C4C4C4;
  border-top: 2px solid #192A3E;
	border-right: 2px solid #192A3E;
  border-radius: 50%;
  width: 20px;
  height: 20px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
